export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "inventory_item": {
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
            "stock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stock"])},
            "item_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descripción"])},
            "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activo"])},
            "inventory_unit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unidad"])}
          }
        }
      }
    }
  })
}